import * as React from 'react';
const AgentsIcon = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" {...props}>
        <g fill="#000" clipPath="url(#a)">
            <path d="m18.379 11.799-3.777-1.49a1.615 1.615 0 0 1-.91-.91l-1.49-3.775c-.537-1.363-2.466-1.363-3.004 0L7.708 9.4a1.615 1.615 0 0 1-.91.91l-3.776 1.489c-1.363.537-1.363 2.466 0 3.004l3.776 1.49c.417.163.746.493.91.91l1.49 3.775c.538 1.363 2.467 1.363 3.005 0l1.49-3.776c.163-.416.493-.745.91-.91l3.776-1.489c1.363-.538 1.363-2.467 0-3.004ZM19.172 7.655a2.827 2.827 0 1 0 0-5.655 2.827 2.827 0 0 0 0 5.655Z" />
        </g>
        <defs>
            <clipPath id="a">
                <path fill="#fff" d="M2 2h20v20H2z" />
            </clipPath>
        </defs>
    </svg>
);
export default AgentsIcon;
